(function AgentCommissionReport($, Adzuki)
{
	"use strict";

	var $modal = $(".modal");

	$(document).ready(function documentReady()
	{
		Adzuki.onload([
			'/Reports/agentCommission',
			'/Reports/associateCommission',
		], function onload()
		{
			$("a.info-link").on('click', function showInfo(e)
			{
				e.preventDefault();
				$modal.find('.modal-title').text("Commission Notes");
				$modal.find('.modal-body').html($(this).data('content'));
				$modal.modal('show');
			});
		});

	});
}(jQuery, window.Adzuki || {}));
